import {StyledComponentProps, StyleRulesCallback} from '@material-ui/styles/withStyles/withStyles'
import clsx from 'clsx'
import React, {useEffect, useRef, useState} from 'react'

import {Grid, GridProps} from '../../grid'
import {Paper} from '../../legacy/paper'
import {makeStyles, Theme, withStyles} from '../../theme'

type ClassKey = 'root' | 'card' | 'content'
type Props = StyledComponentProps<ClassKey> &
  GridProps & {
    grow?: boolean
    sticky?: boolean
  }

const styles: StyleRulesCallback<Theme, Props, ClassKey> = (theme: Theme) => ({
  root: {
    '& + &': {
      marginTop: theme.spacing(1),
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(17),
    boxShadow: 'none',
  },
  content: {
    padding: ({grow}) => (grow ? theme.spacing(1, 1) : theme.spacing(1, 2)),
    margin: 0,

    '&:last-child': {
      paddingBottom: theme.spacing(1),
    },
  },
})
const useStickyClasses = makeStyles(
  {
    root: {
      position: 'sticky',
      bottom: -1,
    },
    card: {
      boxShadow: '0 -4px 20px rgb(117 115 111 / 20%) !important',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  {name: 'StickySectionItem'},
)

const SectionItem: React.FC<React.PropsWithChildren<Props>> = ({children, classes, grow, sticky, ...gridProps}) => {
  const [isSticky, setSticky] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const stickyClasses = useStickyClasses({grow})

  useEffect(() => {
    const element = ref.current

    if (sticky && element) {
      const observer = new IntersectionObserver(([e]) => setSticky(e.intersectionRatio < 1), {threshold: [1]})
      observer.observe(element)

      return () => observer.unobserve(element)
    }
  }, [sticky])

  return (
    <Grid className={clsx(classes.root, sticky && stickyClasses.root)} direction="column" xs={grow} container item>
      <Paper ref={ref} className={clsx(classes.card, {[stickyClasses.card]: isSticky})}>
        <Grid {...gridProps} className={classes.content}>
          {children}
        </Grid>
      </Paper>
    </Grid>
  )
}

export default withStyles(styles, {name: 'SectionItem'})(SectionItem)
